import { render, staticRenderFns } from "./BankHolidaysView.vue?vue&type=template&id=45b90704&"
import script from "./BankHolidaysView.vue?vue&type=script&lang=js&"
export * from "./BankHolidaysView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports